import type { ReactElement } from "react";
import type { SpaceProps } from "styled-system";

// Colors
export enum textColor {
  PRIMARY_500 = "PRIMARY_500",
  PRIMARY_800 = "PRIMARY_800",
  SPECIAL_500 = "SPECIAL_500",
  SPECIAL_700 = "SPECIAL_700",
  ERROR_500 = "ERROR_500",
  ERROR_600 = "ERROR_600",
  ERROR_700 = "ERROR_700",
  WARRING_500 = "WARRING_500",
  BLACK = "BLACK",
  WHITE = "WHITE",
  GRAYSCALE_300 = "GRAYSCALE_300",
  GRAYSCALE_400 = "GRAYSCALE_400",
  GRAYSCALE_500 = "GRAYSCALE_500",
  GRAYSCALE_600 = "GRAYSCALE_600",
  GRAYSCALE_700 = "GRAYSCALE_700",
  GRAYSCALE_900 = "GRAYSCALE_900",
  GOLD = "GOLD",
  BLUE = "BLUE",
}

export const textColors = Object.freeze({ ...textColor });
export type TextColors = (typeof textColors)[keyof typeof textColors];

// Variants
export enum textVariant {
  H1 = "h1",
  H2 = "h2",
  H3 = "h3",
  H4 = "h4",
  H5 = "h5",
  H6 = "h6",
  P = "p",
}

export const textVariants = Object.freeze({ ...textVariant });
export type TextVariants = (typeof textVariants)[keyof typeof textVariants];

// Weight
export enum textWeight {
  BOLD = "bold", // 700
  SEMIBOLD = "semibold", // 600
  MEDIUM = "medium", // 500
  NORMAL = "normal", // 400
  LIGHT = "light", // 300
}

export const textWeights = Object.freeze({ ...textWeight });
export type TextWeights = (typeof textWeights)[keyof typeof textWeights];

// Sizes
export enum textSize {
  XXXL = "xxxl", // 28px
  XXL = "xxl", // 24px
  XL = "xl", // 20px
  L = "l", // 18px
  M = "m", // 16px
  S = "s", // 14px
  XS = "xs", // 12px
  XXS = "xxs", // 10px
}

export const textSizes = Object.freeze({ ...textSize });
export type TextSizes = (typeof textSizes)[keyof typeof textSizes];

export interface TextProps extends SpaceProps {
  text?: string | number | ReactElement;
  variant?: TextVariants;
  color?: TextColors;
  weight?: TextWeights;
  fontSize?: TextSizes;
  textTransform?: "uppercase" | "lowercase" | "capitalize";
  className?: string;
  onClick?: () => void;
  textDecoration?: "underline" | "none" | "line-through";
  textHtml?: string;
  fontClassName?: string;
}
